export const stubDataAllSalesCampaigns = [];
